import { Globals } from 'src/app/shared/services/globals';
import { Injectable } from '@angular/core';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {


  constructor(private httpRes: HttpRequestService ,private global: Globals) { }
  Notifications
  getNotifications(){
    return  this.httpRes.GetRequest('Notification/' + this.global.UserId).toPromise();
  }
}
